module.exports = __webpack_public_path__ + "img/product_100.5eb40e6.svg";